module.exports = __webpack_public_path__ + "static/media/excel.f564a609.svg";